import { ConnectSlackButton } from '@modules/common/components/ConnectSlackButton';
import { useGetTenantSluglessUrl } from '@modules/common/hooks';
import { OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM } from '@modules/subscribe/constants';
import { Box } from '@mui/material';

interface SlackOutboundConnectButtonProps {
  onClick?: () => void;
}

export const SlackOutboundConnectButton = ({
  onClick,
}: SlackOutboundConnectButtonProps) => {
  const currentRoute = useGetTenantSluglessUrl();

  const redirectRouteOnConnect = currentRoute.includes(
    `?${OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM}`,
  )
    ? currentRoute
    : `${currentRoute}?${OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM}=true`;

  return (
    <Box>
      <ConnectSlackButton
        buttonProps={{ color: 'primary', variant: 'outlined', onClick }}
        redirectRouteOnConnect={redirectRouteOnConnect}
      >
        Connect Slack
      </ConnectSlackButton>
    </Box>
  );
};
